import zhHKLocat from 'vxe-table/lib/locale/lang/zh-HK';

export default {
    weekday: {
        1: "Monday",
        2: "Tuesday",
        3: "Wednesday",
        4: "Thursday",
        5: "Friday",
        6: "Saturday",
        7: "Sunday",
    },
    button: {
        back: "Return",
        confirm: "Confirm",
        create: "Add",
        edit: "Edit",
        cancel: "Cancel",
        login: "Log in",
        select_all: "Select all",
        clear: "Reset",
        reset: "Reset",
        connect: "Connect",
        disconnect: "Disconnect",
        default: "Default",
        save: "Save",
        send: "Send",
        reconnect: "Reconnect",
        stop_charging: "Stop charging",
        reboot: "Restart",
        go_detail: "Charging point detail",
        show_charging_detail: "Charging detail",
        mass_update: "Mass update",
        filter: "Filter"
    },
    error: {
        generic: "Error occurred",
        400: "Request error",
        403: "Insufficient operation permissions or account logged out",
        404: "This page does not exist",
        no_changes: "No changes have been made",
        10001: "This charger does not exist!",
        10003: "Please enter a valid duration!",
        10004: "Please enter the last four digits of the mobile phone number!",
        10002: "Charger activation error!",
        10009: "Charging gun error!",
        10011: "Error getting charging data!",
        30001: "Entry time error!",
        30002: "No corresponding transaction record!",
        30003: "Please enter the license plate!",
        10007: "Rsr Not found",
        10008: "Connector error",
        10009: "Connector error",
        10013: "Rsr Invalid",
        10014: "Member ID Invalid",
        10015: "The charging plug is not ready or unavailable",
        10016: "Connector status error",
        10017: "Charging cable not connected",
        10018: "MaxSessionReached",
        10019: "CpChargingRateMissing",
        10022: "Connector cannot use. Chargers only allow maximum one connector charging",
        21001: "Number of session not match",
        21002: "invalid time to redeemed",
        21004: "invalid member id",
        21005: "Failed",
        40001: "Payment Not Found",
        40002: "Payment is Already Settled",
        40003: "Payment is Already retry",
        40004: "Invalid Record",
        40005: "Payment record invalid",
        40006: "Cp is occupied by another Bay",
    },
    menu: {
        group: {
            setting: "System setting",
            management: "Management ",
            operation: "Operation",
            lms: "LMS"
        },
        item: {
            home: "Homepage",
            user: "User",
            role: "User role",
            cp: "Charging point",
            cp_request: "Charging Point Request Log",
            cp_session: "Charging Point Transaction Records",
            cp_rsr: "Charging Point Remote Start Request Log",
            cp_rsr_request: "Charging Point Remote Start Request Records",
            cp_rsr_api_log: "Charging Point Remote Start API Log",
            account: "Account",
            role_n_permission: "Role and Permission Settings",
            privilege: "Privilege",
            vehicle: "Vehicle",
            user_log: "User Log",
            cp_request_test: "LMS Test",
            cp_loc: "Charging Location",
            cp_zone: "Charging Zone",
            lms_dashboard: "LMS Dashboard",
            lms_config: "LMS Settings",
            lms_profile: "LMS Configuration",
            cp_config: "Charging Configuration (Deprecated)",
            cp_simulator: "Charging Point Simulator",
            zone_lms_profile: "Charging Zone LMS Configuration",
            realtime_log: "Real-time LMS Messages",
            account_service_plan: "Account Service Plan",
            service_plan: "Service Plan",
            account_vehicle: "Vehicle Record",
            cp_power_meter: "Power Meter Model",
            data_rotation_setup: "Data Rotation Set Up",
            cp_meter_value: "Meter Value Reading",
            district: "District",
            account_status: "Account Status",
            third_party_conf: "Third-Party Configuration",
            third_party_configuration: "Third-Party Configuration",
            cp_sessions_all: "Charging Point Transaction Records",
            auth_card: "Authorization Card",
            opening_hour: "Operating Hour",
            change_availability: "Change Availibility",
            master_flag: "Administrator Card Checkbox",
            alert: "System Alert",
            contact: "Contact",
            contact_group: "Contact Groups",
            app_config: "System Configuration",
            cp_rsr: "Charging Point RSR",
            cp_rsr_request: "Charging Point RSR Request",
            cp_rsr_api_log: "Charging Point API Log",
            delete: "Delete",
            dashboard_summary: "Dashboard Summary",
            cp_connector: "Charging Gun Configuration",
            charging_rate: "Charging Rate Configuration",
            cp_type: "Charging Gun Type",
            payment_result_detail: "Payment Records",
            third_party_error_log: "API Error Logs",
            remote_start_charger: "Remote Start Charger",
            retry_error_payment: "Repay",
            remote_reset_charger: "Remote Restart ",
            bay: "Parking Bay",
            penalty_button: "Stop Penalty Button",
            bay_log: "Parking Bay Log",
            portal_action_log: "User Operation Logs",
            get_giagnostics: "Get Diagnostics",
            trigger_message: "trigger message",
            user_profile: "user profile",
            voucher: "voucher",
            settled_button: "Manual Settlement"
        }
    },
    label: {
        menu: "Menu",
        trash: "Disabled",
        go_to: "Go to",
        total_record_desc: "Total {row} entries | Total {row} entries, page {page}/{max_page}",
        greeting: "Hello,",
        logout: "Log out",
        no_data_found: "Data not found",
        export_as_: "Export",
        confirm_to_save: "Confirm Save",
        assign_cp_to_zone: "Assign charging points to this charging zone",
        charger: "Charger",
        immediate: "Immediate",
        mode: "Mode",
        max: "Maximum",
        show_per_page: "Show per page",
        all: "All",
        start_charger: "Start Charger",
        stop_charger: "Stop Charger",
        reset_charger: "Restart Charger",
        connector_id: "Connector ID",
        duration: "Duration (minutes)",
        start_code: "PIN",
        lp: "License Plate",
        entry_time: "Entry Time",
        is_free: "Free",
        remark: "Remarks",
        unlock_charger: "Emergency Unlock",
        get_giagnostics: "Get Diagnostics",
        trigger_message: "trigger message",
        status: "Status",
        import: "Import",
        downloadDemo: "Download Template",
        importFile: "Import File",
        confirmImport: "Confirm Import"
    },
    placeholder: {
        please_input: "Please enter",
        please_select: "Please select the appropriate item",
        all_locs: "-- All locations --",
        all_chargers: "-- All chargers --",
        invalid: "invalid"
    },
    filter: {
        start_date: "Start Date",
        end_date: "End Date",
        to: "to",
        boolean: {
            true: "TRUE",
            false: "FALSE"
        }
    },
    select: {
        today: "Today",
        in7days: "in 7 days",
        in1months: "in 30 days",
        all: "All"
    },
    message: {
        logout_warning: "Are you sure you want to log out?",
        login_failed: "Login failed, incorrect account or password",
        server_error: "Server error, please try again later",
        network_error: "Server connection failed, please ensure network connection",
        confirm_n_items_is_changes: "{x} items have been changed, are you sure you want to save?",
        sure_service_restart_required: "After the data is saved, the program will restart. Are you sure you want to save?",
        sure_to_stop_charging_session: "Are you sure you want to terminate the charging for {cp_no}?",
        mass_update_warning: "The following charging points currently do not have charging configuration so batch update is failed",
        save_successfully: "Saved successfully",
        confirm_to_remove_app_secret: "Are you sure you want to remove the configuration of (ID: {id}, Key Name: {key_name})?",
        confirm_to_delete: "Are you sure you want to remove the data of (ID: {id})?",
        confirm: "Confirm",
        cancel: "Cancel",
        9001: "Will also delete all transaction records!",
        change_availability: "Change settings to: {type}",
        cp: "Charging point [{id}]",
        confirm_start_charger: "Confirm {action}?",
        max_limit: "Select up to {limit} maximum",
        maximumQuantity: "Import up to {row} rows maximum",
        pleaseSelectExcelFile: "Please select an Excel file"
    },
    field: {
        general: {
            cp_no: "Charging Point ID",
            connector_id: "Connector ID",
            cp_id: "ID",
            cre_user: "Creator",
            lupd_dttm: "Last Update Date/Time",
            lupd_user: "Last Updater",
            id: "ID",
            cp_name: "Parking Bay ID",
            cre_dttm: "Request Date/Time",
            remark: "Remark",
            remarks: "Remarks",
            session_id: "Session ID",
            cp_config_id: "Configuration ID",
            action_button: "Action Button",
            update_time: "Last Update Date/Time",
            mac_address: "MAC Address",
            ip_address: "IP Address",
            description: "Description",
            fw_ver: "Firmware Version",
            current: "Current",
            pending: "Pending",
            create: "Create",
            request_data: "Request Data",
            response_data: "Response Data",
            api_log_type: "API log type",
            url: "URL",
            id_tag: "ID tag",
            cancel: "Cancel",
            creDttm: "Creation Time",
            lupdDttm: "Last Update Time",
            connectorStatus: "Connector status",
            email: "Email",
            redeem_voucher_sessions: "Actual Usage of Charging Voucher",
            redeem_voucher_size: "Member Size of Charging Voucher",
            redeemVoucherSessions: "Actual Usage of Charging Voucher",
            campaignName: "Campaign",
        },
        contact_group: {
            contact_group_id: "Contact Group ID",
            name: "Name",
            status: "Enabled",
            level: "Receiving Frequency",
            contactIds: "Contact",
            locIds: "Charging Location",
            errorIds: "Error Code",
        },
        contact: {
            contact_id: "Number",
            name: "Name",
            email: "Email",
            status: "Status",
        },
        users: {
            id: "User ID",
            name: "Name",
            role_id: "User Role",
            username: "Username",
            active: "Active",
            password: "Password",
            confirm_password: "Confirm Password",
            cp_loc_flag: "Show All Charging Location",
            loc_id: "Changing Point Location"
        },
        user_profile: {
            id: "User ID",
            name: "Name",
            role_id: "User Role",
            username: "Username",
            active: "Active",
            password: "Password",
            confirm_password: "Confirm Password",
            cp_loc_flag: "Show All Charging Location",
            loc_id: "Changing Point Location"
        },
        roles: {
            name_chi: "Chinese Name",
            role: "User Role",
        },
        alert: {
            alert_id: "Alert ID",
            cp_id: "Charging Point ID",
            error_id: "Error Code",
            location: "Location",
            message: "Message",
            last_date: "Last Updated",
            cre_dttm: "Detection Date",
            level: "Number of Continuous Detections",
            is_fixes: "Fixed",
        },
        portal_action_log: {
            action: "Action",
            target: "Target",
            target_id: "Taget ID",
            old_data: "Old Data",
            new_data: "New Data"
        },
        cps: {
            cp_id: "CP ID",
            name: "Parking Bay ID",
            name_chi: "Parking Bay ID",
            loc_id: "Location",
            firmware_version: "Firmware Version",
            charging_status_code: "Charging Status",
            charging_status: "Charging Status",
            connectora_status: "Charging Connector 1 Status",
            connectorb_status: "Charging Connector 2 Status",
            last_status_dttm: "Last Status Update",
            boot_dttm: "Start Date/Time",
            enable_flag: "Enabled",
            max_power_output: "Maximum Output Power",
            heartbeat_interval: "Heartbeat Interval (seconds)",
            private_flag: "Private Charging Point",
            ac_flag: "Fast Charging",
            dc_flag: "Normal DC Charging",
            mac_addr: "MAC Address",
            ip: "IP Address",
            port: "Port",
            charge_box_serial_number: "Charger ID",
            charge_point_model: "Charging Point Model",
            charge_point_serial_number: "Charging Point Serial Number",
            charge_point_vendor: "Charging Point Vendor",
            iccid: "ICC ID",
            imsi: "IMSI",
            meter_serial_number: "Meter Serial Number",
            meter_type: "Meter Type",
            error_code: "Error Code",
            mct_status_code: "MCT Status Code",
            cre_dttm: "Creation Date/Time",
            connector: "Connector",
            freecharge_flag: "Free Charging Point",
            power_meter_name: "Meter Model",
            power_meter_factor: "Power Factor",
            power_meter_rotation_value: "Maximum Meter Reading",
            mass_update: "Batch Update",
            power_meter_type_id: "Meter Model",
            change_availability: "Suspended",
            min_current_threshold: "Minimum Current",
            min_power_threshold: "Min. Power Warning (Watt)",
            power_meter_type_id: "Meter Model",
            cp_connectors: "Charging Connector",
            charger_type: "Charger Type",
            cp_type: "Charger Type",
            double_use_flag: "Connectors Dual Used"
        },
        cp_requests: {
            tran_id: "Charging Point Transaction ID",
            cp_id: "*Charger ID",
            cp_no: "Charging Point ID",
            req_id: "ID",
            request_type: "Request Type",
            request_data: "Request Data",
            response_data: "Response Data",
            loc: "Location",
            firmware_version: "Firmware Version",
            energy: "Energy (kWh)",
            voltage: "Voltage (V)",
            ampere: "Current (A)",
            charge_box_serial_number: "Charger ID",
            rsr_id: "RSR ID"
        },
        cp_sessions: {
            cp_id: "Charger ID",
            cp_no: "Charging Point ID",
            tran_id: "Charging Point Transaction ID",
            total_pw_consume: "Total Power Used (kWh)",
            total_charge_time: "Total Charging Time",
            running_pw_consume: "Total Running Power Consumption (kWh)",
            session_start_time: "Session Start Time",
            session_end_time: "Session End Time",
            connector_name: "Connector ID",
            account_id: "Account",
            start_meter: "Starting Meter Reading (kWh)",
            end_meter: "Ending Meter Reading (kWh)",
            charge_box_serial_number: "Charger ID",
            start_soc: "Starting State of Charge (SoC) (%)",
            end_soc: "Ending State of Charge (SoC) (%)",
        },
        cp_sessions_all: {
            tran_id: "Charging Point Transaction ID",
            cp_id: "Charger ID",
            cp_no: "Charging Point ID",
            total_pw_consume: "Total Power Used (kWh)",
            total_charge_time: "Total Charging Time",
            running_pw_consume: "Total Running Power Consumption (kWh)",
            session_start_time: "Session Start Time",
            session_end_time: "Session End Time",
            connector_id: "Connector ID",
            account_id: "Account",
            start_meter: "Starting Meter Reading (kWh)",
            end_meter: "Ending Meter Reading (kWh)",
            charge_box_serial_number: "Charger ID",
            start_soc: "Starting State of Charge (SoC) (%)",
            end_soc: "Ending State of Charge (SoC) (%)",
            id_tag: "Card Number"
        },
        payment_result_detail: {
            resultId: "Payment ID",
            paymentType: "Payment Type",
            referenceMemberId: "Member ID",
            status: "Status",
            amount: "Amount ($)",
            point: "Points",
            actionType: "Type",
            requestReference: "Request Reference",
            transactionReference: "Transaction Reference",
            currentUnitSession: "Number of Sessions",
            autoPaymentExpiredTime: "Automatic Payment Expired Time",
            actualFinishedTime: "Total Time including Penalty Time",
            startTime: "Start Time",
            endTime: "End Time",
            gracingPeriodEndDttm: "Grace Period End Time",
            penaltyDuration: "Penalty Time",
            retry: "Retry Payment"
        },
        charging_rate: {
            name: "Rule Name",
// energy_rate:"Energy Rate ($/kWh)",
// time_rate:"Time Rate ($/hour)",
// penalty_rate:"Penalty Rate ($/hour)",
// point_rate:"Point Rate (points/hour)",
// peak_energy_rate:"Energy Rate ($/kWh) (Peak Period)",
// peak_time_rate:"Time Rate ($/hour) (Peak Period)",
// peak_penalty_rate:"Penalty Rate ($/hour) (Peak Period)",
// peak_point_rate:"Point Rate (points/hour) (Peak Period)",
            loc_id: "Charging Point Location",
            gracing_period: "Grace Period",
            max_charging_unit: "Maximum Sections per Session",
            max_penalty_unit: "Maximum Penalty Time (minutes)",
            max_daily_charging_session: "Maximum Daily Charging Sessions",
            redeem_period: "Redeem Deadline (minutes)",
            max_redeem_count: "Maximum Times of Points Redemption",
            unit: "Time Rate Unit",
            type: "Charging Rule",

        }, charging_rate_detail: {
            startTime: "Period Start Time",
            endTime: "Period End Time",
            fee: "Cost per Session",
            peak: "Peak Period",
            point: "Points",
// weekday:"Weekday",
            penaltyUnit: "Penalty Unit",
            unit: "Unit",
            penaltyFee: "Penalty Fee",
            maxChargingUnit: "Maximum Sections per Session",
        },
        cp_rsr: {
            rsr_id: "ID",
            actual_end_time: "Actual Ending Time",
            cancel_time: "Cancellation Time",
            connector_id: "Connector ID",
            duration: "Charging Time (minutes)",
            end_time: "End Time",
            lp: "License Plate",
            start_code: "PIN",
            start_time: "Start Charging Time",
            status: "Status",
            payment_status: "Payment Status",
            payment_status_name: "Payment Status",
            charging_fee: "Charging Fee",
            penalty_fee: "Penalty Fee",
            point: "Points Redeemed",
            tran_id: "Charging Point Transaction ID",
            unit_in_minutes: "Unit Time (minutes)",
            rate: "Unit Rate",
            uuid: "UUID",
            stop_type: "Stop Method",
            stop_type_name: "Stop Method",
            stop_reason: "Stop Reason",
            external_account_id: "Member ID",
            carpark_id: "Car Park ID",
            mall_id: "Mall ID",
            loc_address: "Mall Address",
            connector_name: "Connector ID",
            payment_result_id: "Payment ID",
            current_unit_session: "Electricity Sections",
            brand_in: "Entry Brand",
            lp_in: "Entry License Plate",
            brand_out: "Exit Brand",
            lp_out: "Exit License Plate",
            in_time: "Entry Time",
            out_time: "Exit Time",
            lprs_session_id: "LPRS Session ID",
            lprs_out_session_id: "LPRS Exit Session ID",
            ev_disconnect_time: "EV Disconnected Time",
            actual_finished_time: "Stop Penalty Time",
            penalty_button: "Penalty Time Adjustment",
            settled_button: "Manual Payment Completion",
            bay_id_int: "Parking Bay Number",
            bay_id: "Parking Bay",
            bay_name: "Parking Bay",
            gracing_period_end_dttm: "Grace Period End Time",
            cre_dttm: "Creation Time",
            penalty_mode: "Penalty Rule"
        },
        third_party_error_log: {
            action: "Action",
            carparkId: "Car Park ID",
            mallId: "Mall ID",
            memberId: "Member ID",
            chargerId: "Charging Point ID",
            connectorId: "Connector ID",
            connectorStatus: "Connector Status",
            errorCode: "Error Code",
            errorTime: "Error Time",
            reason: "Reason",
            rsrId: "RSR ID"
        },
        cp_session_detail: {
            energy: "Meter Value (kWh)",
            voltage: "Voltage (V)",
            ampere: "Current (A)",
        },
        cp_pow: {
            name: "Name",
            factor: "Multiplier",
            rotation_value: "Maximum Meter Value"
        },
        accounts: {
            acc_id: "Account number",
            first_name: "First name",
            last_name: "Last name",
            mobile_no: "Phone number",
            email: "Email",
            acc_bal: "Account Balance",
            hkid: "ID/Passport (first 3 digits)",
            birthday: "Birthday",
            acc_status: "Account status",
            default_lang: "Default language",
            tnc_flag: "TnC user",
            rfid_cards: "RFID card (separated by \", \")",
            address: "Address",
            reg_dttm: "Registration date and time",
            car_reg_no: "Vehicle number",
            locIds: "Charging location",
            master_flag: "Admin card",
            max_charge_time: "Maximum Charging Time (mins)"
        },
        privileges: {
            name: "name",
            enable_flag: "enabled",
        },
        vehicles: {
            vehicle_id: "Vehicle number"
        },
        user_log: {
            user_log_id: "User Log ID",
            msg: "Log Content",
            type: "Category",
            ip: "IP Address",
            user_id: "Username",
        },
        cp_locs: {
            loc_id: "Number",
            address: "Address",
            enable_flag: "Enabled",
            provider_id: "Supplier",
            mode_id: "Charging Rate Mode",
            district_id: "District",
            address_chi: "Address (Chinese)",
            address_chs: "Address (Simplified Chinese)",
            gps_lat: "Latitude",
            gps_lang: "Longitude",
            rate_id: "Charging Rate",
            min_charging_unit: "Minimum Charging Unit (Prepaid)",
            max_charging_unit: "Maximum Charging Unit (Prepaid)",
            default_charging_unit: "Default Charging Unit (Prepaid)",
            free_charge_flag: "Free",
            postpaid_min_charge: "Minimum Fee (HKD) (Postpaid)",
            postpaid_max_charge: "Maximum Fee (HKD) (Postpaid)",
            postpaid_allowance_min: "Grace Period (minutes) (Postpaid)",
            lms_profile_id: "LMS Configuration",
            enable_lms: "Enable LMS",
            external_loc_id: "Car Park ID",
            mall_id: "Mall ID",
            station_code: "Car Park ID",
            contact_number: "Contact Number"
        },
        bay: {
            bayId: "Parking Bay Number",
            bayName: "Parking Bay Name",
            cpLocId: "Car Park",
            cpConnector: "Connector",
            locId: "Car Park ID",
            mallId: "Mall ID",
            cpId: "Charging Point",
            connectorId: "Connector",
            brand: "Brand",
            licensePlate: "License Plate",
            inTime: "Entry Time",
            outTime: "Exit Time",
            type: "Parking Bay Type",
            status: "Parking Bay Status",
            image: "Car Image",
            autoDownloadFlag: "Auto Download Image",
            penaltyMode: "Penalty Rule",
            urlGetBayInfo: "Parking Bay Status API URL"
        },
        bay_log: {
            sessionId: "LPRS Period ID",
            bayId: "Parking Bay ID",
            brand: "Brand",
            licensePlate: "License Plate",
            image: "Car Image",
            imageLocalPath: "Car Image",
            locId: "*Car Park ID",
            mallId: "Mall ID",
            inTime: "Entry Time",
            outTime: "Exit Time",
            creDttm: "Creation Time",
            errorCode: "Error Code",
            response: "API Response",
            status: "Status",
            requestStatus: "Request Status",
            bayUpdateStatus: "Parking Bay Update Status",
            relatedRsr: "RSR Number",
        },
        cp_zones: {
            zone_id: "Number",
            loc_id: "Location",
            name_chi: "Name",
            max_physical_current_limit: "Maximum Physical Current Limit"
        },
        role_n_permission: {
            read: "Read",
            create: "Create",
            edit: "Edit",
            other: "Other"
        },
        lms: {
            mode: "Mode",
            zone_max_available_current: "Maximum Available Current in Area",
            max_charging_current: "Maximum Charging Current",
            min_charging_current: "Minimum Charging Current",
            zone_name: "Zone Name"
        },
        lms_profiles: {
            lms_profile_id: "Number",
            name: "Name",
            cp_loc: "Location",
            mode: "Mode",
        },
        account_service_plans: {
            asp_id: "Number",
            start_date: "Plan Start Date",
            end_date: "Plan End Date",
            acc_id: "Account",
            plan_id: "Service Plan",
            plan_total: "Total Plan Amount",
            cp_id: "Charging Point Number"
        },
        service_plans: {
            plan_id: "plan id",
            name: "Name"
        },
        account_vehicles: {
            acc_id: "Vehicle Number",
            cp: "Charging Point",
            car_reg_no: "Vehicle License Plate",
            monthly_charging_time: "Monthly Charging Time",
            monthly_charged_energy: "Monthly Energy Charged  (kWh)",
            daily_charging_time: "Daily Charging Time",
            daily_charged_energy: "Daily Energy Charged (kWh)",
            acc_status: "Vehicle Status",
            rfid_cards: "RFID Card (separated by ,)"
        },
        data_rotation_setup: {
            period_month: "Retention Time (Months)",
            is_enabled: "Enabled",
        },
        sys_logs: {
            log_message: "Log",
            created_dt: "Created Date/Time"
        },
        third_party_conf: {
            key_name: "Key Name",
            app_id: "App ID",
            assigned: "Authorized",
            privilege_key: "Permission",
            api_key: "API Key"
        },
        auth_card: {
            name: "Name",
            rfid_cards: "RFID Card (separated by commas)",
            loc: "Charging Location",
            cp: "Charger",
            active: "Enabled"
        },
        opening_hour: {
            opening_hour_id: "ID",
            name: "Name",
            start_time: "Start Time",
            end_time: "End Time",
            weekday: "Weekday",
        },
        voucher: {
            memberId: "Member ID",
            rsrId: "RSR ID",
            status: "Status",
            creUserName: "Creator",
            deleteDttm: "Deletion Date",
            address: "Address",
            redeemDttm: "Redeem Date",
            voucherExpireDate: "Expiry Date"
        }
    },
    input_error: {
        already_taken: "Already Used",
        already_exist: "Already Existed",
        email_is_null: "Required to fill",
        email_duplicate: "Already Exists",
        email_error: "Format Error",
        status_error: "Please select (Contact Person, Charging Location, Error Code)",
        CARD_NO_ALREADY_EXIST: "Number has been used by another account",
        END_TIME_MORE_THAN_START_TIME: "Must be greater than the start time",
        REQUIRED: "Required",
        DUPLICATE_KEY: "Already Used",
        MAX_CHARGE_TIME_NOT_INTEGER: "must be an integer",
        MAX_CHARGE_TIME_NOT_IN_RANGE: "must be in the range: 0 - 1440"
    },

    unit: {
        sec: "Time"
    },

    dashboard: {
        status: {
            Available: "Available",
            Faulted: "Faulted",
            Finishing: "Finishing",
            Preparing: "Preparing",
            Reserved: "Reserved",
            SuspendedEV: "Suspended EV",
            SuspendedEVSE: "Suspended EV",
            Unavailable: "Unavailable",
            Charging: "Charging",
            Offline: "Offline",
            na: "Not Available",
        },
        daterange: {
            yesterday: "Yesterday",
            today: "Today",
            weekly: "Last 7 days"
        },
        unit: {
            time: {
                hr: "Hour",
                min: "Min",
            },
        },
        label: {
            charging_status: "Charging Status",
            usage: "Usage",
            used: "Used",
            not_used: "Unused",
            consumption: "Power Consumption",
            start_from: "Started from",
            end_on: "Ended at",
            not_in_use: "Not In Use",
            voltage: "Voltage",
            current: "Current",
            time: "Time",
            bayStatus: "Parking Bay Status",
            bayLupdDttm: "Last Update Time of Parking Bay"
        }
    },
    lms: {
        label: {
            start_tran_at: "Start Charging Time",
            start_queueing_at: "Start Queueing Time",
            charging_end_at: "Expected End Time",
            select_time: "Selected Charging Time"
        },
        mode: {
            unknown: "Unknown",
            queueing: "Queuing ",
            distribution: "Distribution",
            mixmode: "Mixed mode",

        },
        status: {
            available: "Available",
            charging: "Charging",
            disconnected: "Disconnected",
            queueing: "Queuing",
            Available: "Available",
            Faulted: "Faulted",
            Finishing: "Finishing",
            Preparing: "Preparing",
            Reserved: "Reserved",
            SuspendedEV: "Suspended EV",
            SuspendedEVSE: "Suspended EV",
            Unavailable: "Unavailable",
            Charging: "Charging"
        }
    },
    data_rotation_setup: {
        item: {
            cp_request: "CP request",
            cp_session: "CP session",
            cp_meter_value: "Meter Value",
            transaction: "Trasaction Record"
        }
    },


    ...zhHKLocat
}